export const SET_SIGNALR_HUB = 'SET_SIGNALR_HUB'
export const SET_CHAT_NEW_MESSAGE_WARNING = 'SET_CHAT_NEW_MESSAGE_WARNING'